var map = {
	"./loc_#00a859_26.png": "ddbc",
	"./loc_#1296db_26.png": "6a95",
	"./loc_#d81e06_26.png": "04b2",
	"./loc_blue_26.png": "eae4",
	"./loc_red_26.png": "7d13"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e20";